import React, { memo, useMemo } from 'react';

import { Icon as IconUi } from '@sravni/react-design-system/lib/Icon';
import {
  Briefcase,
  Calendar,
  CardPlus as CardIncoming,
  CardTerminal as CardPay,
  CardTimer as CardWaiting,
  CardTransfer,
  Clock,
  Exchange as Transfer,
  Flashlight,
  Orders,
  Percent,
  Plane,
  PrizeCup as Challenge,
  Rotate,
  RubleExchange as RubRotate,
  Shield as Protection,
  UserProfile as Profile,
  Wallet,
  WalletBag as Purse,
} from '@sravni/react-icons';
import WidgetIcons from '@sravni/vitrina/lib/enums/WidgetIcons';

import type { ICON_SIZES } from '../../../../constants/icon';

import CardPercent from './Icons/CardPercent';
import Circulation from './Icons/Circulation';

interface IIconProps {
  config: WidgetIcons;
  size?: typeof ICON_SIZES[keyof typeof ICON_SIZES];
}

const Icon: React.FC<IIconProps> = memo(({ config, size = 28 }) => {
  const icon = useMemo(() => {
    switch (config) {
      case WidgetIcons.CardIncoming:
      case WidgetIcons.CardSpending:
        return <CardIncoming />;
      case WidgetIcons.CardWaiting:
        return <CardWaiting />;
      case WidgetIcons.CardPay:
        return <CardPay />;
      case WidgetIcons.CardTransfer:
        return <CardTransfer />;
      case WidgetIcons.Transfer:
        return <Transfer />;
      case WidgetIcons.RubRotate:
        return <RubRotate />;
      case WidgetIcons.Rotate:
        return <Rotate />;
      case WidgetIcons.Percent:
        return <Percent />;
      case WidgetIcons.Protection:
        return <Protection />;
      case WidgetIcons.Challenge:
        return <Challenge />;
      case WidgetIcons.Briefcase:
        return <Briefcase />;
      case WidgetIcons.Orders:
        return <Orders />;
      case WidgetIcons.Wallet:
        return <Wallet />;
      case WidgetIcons.Clock:
        return <Clock />;
      case WidgetIcons.Plane:
        return <Plane />;
      case WidgetIcons.Purse:
        return <Purse />;
      case WidgetIcons.Flashlight:
        return <Flashlight />;
      case WidgetIcons.Profile:
        return <Profile />;
      case WidgetIcons.Calendar:
        return <Calendar />;
      case WidgetIcons.CardPercent:
        return <CardPercent />;
      case WidgetIcons.Circulation:
        return <Circulation />;
      default:
        throw Error(`Not found icon for ${config}`);
    }
  }, [config]);

  return <IconUi icon={icon} size={size || 28} color="blue" />;
});

export default Icon;
